import { render } from "./RefferalsList.vue?vue&type=template&id=b78ea0fa"
import script from "./RefferalsList.vue?vue&type=script&lang=js"
export * from "./RefferalsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__